import React from "react";
import { Field } from "formik";
import { CTA, InputField, PhoneInputField } from "@coverme/forms";
import * as formsService from "../../services/formsService";
import { CurrencyInput } from "../FormComponents/CurrencyInput";
import { coverageSummaryValidationSchema } from "./validationSchema";
import { AddAdditional, CurrencyInputField, LabelledCheckbox } from "@coverme/forms";

const InterviewCoverageForm = ({ baseKey = "", isPrimaryCoverage = true, ...props }) => {
    const { setFieldValue, setFieldTouched, resetForm, handleSubmit, errors, touched, values } = props;
    const getValidationState = formsService.getValidationState.bind(this, errors, touched);
    const getErrors = formsService.getErrors.bind(this, errors);
    const isRequired = formsService.isRequired.bind(this, coverageSummaryValidationSchema, values);
    return (
        <form>
            <div className="interview-coverage-collected-form__field">
                <Field name={`${baseKey}.companyName`}>
                    {({ field }) => (
                        <InputField
                            {...field}
                            id={field.name}
                            title="Company Name"
                            placeholder="Company Name"
                            errorMessage={getErrors(field)}
                            required={isRequired(field)}
                            validState={getValidationState(field)}
                        />
                    )}
                </Field>
            </div>
            <div className="interview-coverage-collected-form__field">
                <Field
                    name={`${baseKey}.address`}
                    render={({ field }) => (
                        <InputField
                            id={field.name}
                            title="Address"
                            placeholder={"1234 Street Name, Apt, Suite"}
                            errorMessage={getErrors(field)}
                            required={isRequired(field)}
                            validState={getValidationState(field)}
                            {...field}
                        />
                    )}
                />
            </div>
            <div className="interview-coverage-collected-form__field">
                <Field
                    name={`${baseKey}.phoneNumber`}
                    render={({ field }) => (
                        <PhoneInputField
                            {...field}
                            title="Phone Number"
                            id={field.name}
                            value={field.value}
                            errorMessage={getErrors(field)}
                            required={isRequired(field)}
                            validState={getValidationState(field)}
                            changeEvent={e => {
                                setFieldValue(`${baseKey}.phoneNumber`, e);
                            }}
                        />
                    )}
                />
            </div>
            <div className="interview-coverage-collected-form__field">
                <Field name={`${baseKey}.plan`}>
                    {({ field }) => (
                        <InputField
                            {...field}
                            id={field.name}
                            required={isRequired(field)}
                            title="Plan"
                            placeholder="Plan"
                            errorMessage={getErrors(field)}
                            validState={getValidationState(field)}
                        />
                    )}
                </Field>
            </div>
            <div className="interview-coverage-collected-form__field">
                <Field name={`${baseKey}.groupNumber`}>
                    {({ field }) => (
                        <InputField
                            {...field}
                            id={field.name}
                            title="Group Number"
                            placeholder="Group Number"
                            required={isRequired(field)}
                            errorMessage={getErrors(field)}
                            validState={getValidationState(field)}
                        />
                    )}
                </Field>
            </div>
            <div className="interview-coverage-collected-form__field">
                <Field name={`${baseKey}.employer`}>
                    {({ field }) => (
                        <InputField
                            {...field}
                            id={field.name}
                            title="Employer"
                            placeholder="Employer"
                            required={isRequired(field)}
                            errorMessage={getErrors(field)}
                            validState={getValidationState(field)}
                        />
                    )}
                </Field>
            </div>
            <div className="interview-coverage-collected-form__field">
                <Field name={`${baseKey}.memberId`}>
                    {({ field }) => (
                        <InputField
                            {...field}
                            id={field.name}
                            title="Member ID"
                            placeholder="Member ID"
                            errorMessage={getErrors(field)}
                            required={isRequired(field)}
                            validState={getValidationState(field)}
                        />
                    )}
                </Field>
            </div>
            {isPrimaryCoverage && (
                <>
                    <fieldset>
                        <legend> Co-Pay Amounts </legend>
                        <div className="interview-coverage-collected-form__copay">
                            <Field name={`${baseKey}.copay.erInPlanNetwork`}>
                                {({ field }) => (
                                    <CurrencyInputField
                                        {...field}
                                        id={field.name}
                                        value={field.value}
                                        title="ER"
                                        placeholder="ER"
                                        errorMessage={getErrors(field)}
                                        required={isRequired(field)}
                                        validState={getValidationState(field)}
                                        changeEvent={e => {
                                            setFieldValue(`${baseKey}.copay.erInPlanNetwork`, e);
                                        }}
                                    />
                                )}
                            </Field>
                        </div>
                        <div className="interview-coverage-collected-form__copay">
                            <Field name={`${baseKey}.copay.office`}>
                                {({ field }) => (
                                    <CurrencyInputField
                                        {...field}
                                        id={field.name}
                                        value={field.value}
                                        title="Office"
                                        placeholder="Office"
                                        errorMessage={getErrors(field)}
                                        required={isRequired(field)}
                                        validState={getValidationState(field)}
                                        changeEvent={e => {
                                            setFieldValue(`${baseKey}.copay.office`, e);
                                        }}
                                    />
                                )}
                            </Field>
                        </div>
                    </fieldset>

                    <div className="interview-coverage-collected-form__field">
                        <Field name={`${baseKey}.remainingDeductible.inPlanNetwork`}>
                            {({ field }) => (
                                <CurrencyInputField
                                    {...field}
                                    id={field.name}
                                    title="Deductible Remaining"
                                    value={field.value}
                                    errorMessage={getErrors(field)}
                                    validState={getValidationState(field)}
                                    required={isRequired(field)}
                                    changeEvent={e => {
                                        setFieldValue(`${baseKey}.remainingDeductible.inPlanNetwork`, e);
                                    }}
                                />
                            )}
                        </Field>
                    </div>
                    <div className="interview-coverage-collected-form__field">
                        <Field name={`${baseKey}.remainingOutOfPocket.inPlanNetwork`}>
                            {({ field }) => (
                                <CurrencyInputField
                                    {...field}
                                    id={field.name}
                                    value={field.value}
                                    errorMessage={getErrors(field)}
                                    required={isRequired(field)}
                                    validState={getValidationState(field)}
                                    title="Out of Pocket Remaining"
                                    changeEvent={e => {
                                        setFieldValue(`${baseKey}.remainingOutOfPocket.inPlanNetwork`, e);
                                    }}
                                />
                            )}
                        </Field>
                    </div>
                </>
            )}
        </form>
    );
};

export default InterviewCoverageForm;
